import Logo from "../../../components/UI/Logo/Logo";
import mtorVector from "../../../assets/icons/mtor_vector.svg";
import fire from "../../../assets/icons/fire.svg";
import appStore from "../../../assets/images/app_store.png";
import googlePlay from "../../../assets/images/google_play.png";
import qrCode from "../../../assets/icons/qr_code.svg";
import appMockup from "../../../assets/images/app_mockup.png";
import classes from "./MobileApplicationSection.module.css";

const MobileApplicationSection = () => {
  return (
    <section className={classes["mobile-application"]}>
      <div className={classes["mobile-application__about"]}>
        <div className={classes["mobile-application__content"]}>
          <img
            src={mtorVector}
            alt="mtor"
            className={classes["mobile-application__mtor-vector"]}
          />
          <Logo />
          <p className={classes["mobile-application__download-text"]}>
            حمل أبليكيشن موتور
          </p>
          <h1 className={classes["mobile-application__header"]}>
            حمل الأبليكيشن و إشتري كل قطع الغيار اللي محتاجها
            <img
              src={fire}
              alt="fire"
              className={classes["mobile-application__fire"]}
            />
          </h1>
          {/* <p className={classes["mobile-application__text"]}>
            هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي
            القارئ عن التركيز
          </p> */}
          <div className={classes["mobile-application__links"]}>
            <div className={classes["mobile-application__qr-code"]}>
              <img src={qrCode} alt="QR code" />
            </div>
            <div className={classes["mobile-application__store-links"]}>
              <a
                href="https://apps.apple.com/eg/app/mtor-%D9%85%D8%B1%D9%83%D8%B2-%D8%AE%D8%AF%D9%85%D8%A9/id1643559485"
                target="_blank"
                rel="noreferrer"
                className={classes["mobile-application__store-link"]}
              >
                <img src={appStore} alt="app store" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=mtor.mtor_mechanicapp"
                target="_blank"
                rel="noreferrer"
                className={classes["mobile-application__store-link"]}
              >
                <img src={googlePlay} alt="google play" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <img
        src={appMockup}
        alt="mechnaic app"
        className={classes["mobile-application__mockup"]}
      />
    </section>
  );
};

export default MobileApplicationSection;
